module.exports = __webpack_public_path__ + "static/media/back_picture.44d536ab.png";